export const GET_ALL_ANNOUNCEMENTS = 'GET_ALL_ANNOUNCEMENTS'
export const ADD_ANNOUNCEMENT = 'ADD_ANNOUNCEMENT'
export const REMOVE_ANNOUNCEMENT = 'REMOVE_ANNOUNCEMENT'
